// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vuex from 'vuex'
import VueScroller from 'vue-scroller'
import VueLazyload from 'vue-lazyload'
import utils from '@/utils/utils';
import 'babel-polyfill'

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// 客户端调用返回分享结果
window.gotShareFromNative = () => {
  if (store.state.activity.shareStatus == -1) { // 首次分享，上报
    // 分享成功,更新store
    store.commit('activity/reportShare');
  }
}

utils.getAppDeviceId();

// 存储用户信息
// if (MG.utils.getQueryString('userId') && location.href.indexOf('/fissionActivity/assist') == -1) {
//   // 过滤掉/fissionActivity/assist这个url
//   utils.storeUserInfo();
// }

if (MG.utils.getQueryString('userId')) {
    utils.storeUserInfo();
}

Vue.use(VueLazyload, {
  loading: require('./assets/lazy_load.gif'),
  attempt: 1,
})

Vue.use(Vuex)
Vue.use(VueScroller)


Vue.config.productionTip = false

let bus = new Vue()
Vue.prototype.bus = bus
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js